import React from "react";
import { Box, AppBar, Hidden } from "@mui/material";
import { DesktopAppbar } from "./header/DesktopAppbar";
import { MobileAppbar } from "./header/MobileAppbar";

export const Header = ({ func, translate, pages }) => {
  const handleChangeLanguage = (lang) => {
    func(lang);
  };

  return (
    <Box
      sx={{
        minHeight: { xs: "95px", md: "120px" },
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
    >
      <AppBar
        position="fixed"
        color="black"
        sx={{ minHeight: { xs: "95px", md: "120px" } }}
      >
        <Hidden mdDown>
          <DesktopAppbar
            func={handleChangeLanguage}
            translate={translate}
            pages={pages}
          />
        </Hidden>
        <Hidden mdUp>
          <MobileAppbar
            func={handleChangeLanguage}
            translate={translate}
            pages={pages}
          />
        </Hidden>
      </AppBar>
    </Box>
  );
};
